import { requireAdmin } from "@/lib/admin-guard";
import { getSettingsForCategory } from "@/lib/settings";
import { SettingsForm } from "@/components/admin/settings-form";
import { updateSettingsAction } from "@/app/admin/_actions";

export const dynamic = "force-dynamic";

export default async function AdminSiteSettings() {
  await requireAdmin();
  const [site, seo] = await Promise.all([
    getSettingsForCategory("site"),
    getSettingsForCategory("seo"),
  ]);

  return (
    <div className="space-y-10">
      <SettingsForm
        category="site"
        title="Site Settings"
        hint="Tên trang, footer disclaimer, contact email — đổi không cần restart."
        settings={site}
        action={updateSettingsAction}
      />
      <SettingsForm
        category="seo"
        title="SEO / Analytics"
        hint="Google Analytics + Tag Manager IDs. Để trống = tắt."
        settings={seo}
        action={updateSettingsAction}
      />
    </div>
  );
}
